<template>
  <div class="timisoara">
    <h1>Timişoara, Temeschburg, Temesvar</h1>
    <article>
      Doriţi o prelungare? Faceţi un click pe o posa!
Posele marcat cu "nn" nu sânt de la mine.<br/>
				Klicken Sie auf ein Foto, 
				um eine Vergrößerung zu erhalten<br>
				Mit (nn) markierte Fotos stammen nicht von mir.
    </article>
    <article class="fotos">
      <div class="foto">
        <img src="../assets/fotos/timi_6kl.jpg" width="125" height="110" border="0" alt="Temeschwar / Timişoara: 
serbisches Vicariat" @click="callImageClick('Temeschwar / Timişoara: serbisches Vicariat', 'timi_6.jpg', $event)">
        <br>Temeschwar / Timişoara: serbisches Vicariat
      </div>
      <div class="foto">
        <img src="../assets/fotos/timi_9kl.jpg" width="121" height="110" border="0" alt="Temeschwar / Timişoara: orthodoxe Kathedrale"
        @click="callImageClick('Temeschwar / Timişoara: Temeschwar / Timişoara: orthodoxe Kathedrale', 'timi_9.jpg', $event)">
        <br>Temeschwar / Timişoara: orthodoxe Kathedrale
      </div>
      <div class="foto">
        <img src="../assets/fotos/timi_1kl.jpg" width="125" height="110" border="0" alt="Temeschwar / Timişoara: rö-kath. Dom"
        @click="callImageClick('Temeschwar / Timişoara: rö-kath. Dom', 'timi_1.jpg', $event)">
        <br>Temeschwar / Timişoara: rö-kath. Dom, Gemälde in Reschitza
      </div>
      <div class="foto">
        <img src="../assets/fotos/timi_8kl.jpg" width="125" border="0" height="110" alt="Altarbibel einer evangelischen Kirche" 
        @click="callImageClick('Altarbibel einer evangelischen Kirche', 'timi_8.jpg', $event)">
        <br>Altarbibel einer evangelischen Kirche
      </div>
      <div class="foto">
        <img src="../assets/fotos/timi_2kl.jpg" width="125" height="110" border="0" alt="Temeschwar / Timişoara:  
        Friedhof der Opfer der Revolution von 1989" 
        @click="callImageClick('Temeschwar / Timişoara: Friedhof der Opfer der Revolution von 1989', 'timi_2.jpg', $event)">
        <br />Temeschwar / Timişoara: Friedhof der Opfer der Revolution von 1989
      </div>
      <div class="foto">
        <img src="../assets/fotos/timi_7kl.jpg" width="105" height="110" border="0" alt="Temeschwar / Timişoara: rö-kath. Dom" 
        @click="callImageClick('Temeschwar / Timişoara: rö-kath. Dom', 'timi_7.jpg', $event)">
        <br/>Temeschwar / Timişoara: rö-kath. Dom
      </div>
      <div class="foto">
        <img src="../assets/fotos/timi_10kl.jpg" width="125" height="110" border="0" alt="Temeschwar / Timişoara: Brunnen der Himmelsrichtungen" 
        @click="callImageClick('Temeschwar / Timişoara: Brunnen der Himmelsrichtungen', 'timi_10.jpg', $event)">
        <br/>Temeschwar / Timişoara: Brunnen der Himmelsrichtungen"
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
  callImageClick(imgText, imgName, event) {
     this.$parent.handleImageClick(imgText, imgName, event);
    }
  }
}
</script>